import { render, staticRenderFns } from "./CreatePurchaseRequisition.vue?vue&type=template&id=7a68dbb2&scoped=true&"
import script from "./CreatePurchaseRequisition.vue?vue&type=script&lang=ts&"
export * from "./CreatePurchaseRequisition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a68dbb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a68dbb2')) {
      api.createRecord('7a68dbb2', component.options)
    } else {
      api.reload('7a68dbb2', component.options)
    }
    module.hot.accept("./CreatePurchaseRequisition.vue?vue&type=template&id=7a68dbb2&scoped=true&", function () {
      api.rerender('7a68dbb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/purchase-requisition/CreatePurchaseRequisition.vue"
export default component.exports